module.exports = {"api":"/v1"};